import { Route } from 'src/routes/Route'

export const PaymentSettingsRoute = Route({ path: '/payment-settings' })
export type PaymentSettingsRoute = Route<typeof PaymentSettingsRoute>
